export enum ChargeType {
  OnceOff = 'OnceOff',
  Recurring = 'Recurring',
  Usage = 'Usage',
  Discount = 'Discount',
  WheelingUsageFirm = 'WheelingUsageFirm',
  WheelingUsageNonFirm = 'WheelingUsageNonFirm',
  WheelingGeneration = 'WheelingGeneration',
  WheelingPenaltyDeemedEnergy = 'WheelingPenaltyDeemedEnergy',
  WheelingUsageCapped = 'WheelingUsageCapped'
}

export const chargeTypeDisplayNames = {
  [ChargeType.OnceOff]: 'Once-Off',
  [ChargeType.Usage]: 'Usage',
  [ChargeType.Recurring]: 'Recurring',
  [ChargeType.WheelingUsageNonFirm]: 'Non Firm',
  [ChargeType.WheelingUsageFirm]: 'Firm',
  [ChargeType.WheelingGeneration]: 'Eskom Generation Wheeling Charge',
  [ChargeType.Discount]: 'Discount',
  [ChargeType.WheelingPenaltyDeemedEnergy]: 'Deemed Energy',
  [ChargeType.WheelingUsageCapped]: 'Capped',
} as const satisfies Record<ChargeType, string>

// TODO This should be converted to a string value in asset management.
export enum InvoiceStatusNumeric {
  ActionRequired = 1,
  Draft = 2,
  Approved = 3,
  Sent = 4,
  Cancelled = 5,
  Paid = 6,
}

export const Seasons = [
  { id: 1, name: `Summer` },
  { id: 2, name: `Winter` }
]

export const TimeOfUsePeriods = [
  { id: 1, name: `Peak` },
  { id: 2, name: `Standard` },
  { id: 3, name: `Off-Peak` }
]

export enum InvoiceDataSourceType {
  ProForma = 'proforma',
  Final = 'final',
}
